var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address-list-warp"},[_c('AddressList',{attrs:{"switchable":false,"list":_vm.list,"disabled-list":_vm.disabledList,"default-tag-text":"默认"},on:{"click-item":_vm.setAddress,"add":_vm.onAdd,"edit":_vm.onEdit},model:{value:(_vm.chosenAddressId),callback:function ($$v) {_vm.chosenAddressId=$$v},expression:"chosenAddressId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }